// Vendor
import { EventEmitter } from '@angular/core';
// Utils / Constants
import { INVALID_TITLE_CHARACTERS_ERROR, INVALID_TITLE_CHARS, MISSING_REPORT_TITLE_ERROR, REPORT_TITLE_LENGTH_ERROR, } from './pdf-title-modal.constants';
import * as i0 from "@angular/core";
import * as i1 from "../modals/modal-base/components/modal-base.component";
import * as i2 from "../modals/modal-base/components/simple-modal-header.component";
import * as i3 from "@angular/forms";
import * as i4 from "@angular/common";
const _c0 = a0 => ({ "is-invalid": a0 });
const _c1 = a0 => ({ disabled: a0 });
function PdfTitleModalComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 13);
} if (rf & 2) {
    const error_r1 = ctx.$implicit;
    i0.ɵɵproperty("textContent", error_r1);
} }
/**
 * PDF Title Modal
 *
 * Defines a simple modal used when downloading a PDF. It allows for entering a title for the report that is used
 * for the Compliance Report title and the title text of the PDF.
 *
 * @ defaultTitle: Optional default for the report title.
 * @ checkInvalidCharacters: Whether it should validate special characters or not. Default value true.
 * @ submitButtonText: Text to display on the Submit button.
 * & submitHandler: Function to run when the modal is submitted. The state of the modal is passed as an argument.
 *
 */
export class PdfTitleModalComponent {
    constructor() {
        this.checkInvalidCharacters = true;
        this.maxTitleLength = 40;
        this.submitHandler = new EventEmitter();
        this.isValid = true;
        this.errorMessages = {
            titleChars: null,
            titleLength: null,
            titleEmpty: null,
        };
        this.mapStateToComponent = (state) => {
            this.reportTitle = state.reportTitle;
        };
    }
    ngOnInit() {
        this.reportTitle = this.defaultTitle;
    }
    resetState() {
        this.reportTitle = this.defaultTitle;
        this.isValid = true;
    }
    resetAll() {
        this.resetState();
        this.errorMessages = {
            titleChars: null,
            titleLength: null,
            titleEmpty: null,
        };
        this.isValid = true;
        this.isFirstAttempt = true;
    }
    validateReportTitle() {
        if (this.isFirstAttempt)
            return;
        this.errorMessages.titleChars = null;
        this.errorMessages.titleLength = null;
        this.errorMessages.titleEmpty = null;
        if (!this.reportTitle) {
            this.errorMessages.titleEmpty = MISSING_REPORT_TITLE_ERROR;
            this.isValid = false;
            return;
        }
        if (this.reportTitle.length > this.maxTitleLength) {
            this.errorMessages.titleLength = this.maxTitleLength + REPORT_TITLE_LENGTH_ERROR;
        }
        if (this.checkInvalidCharacters &&
            Array.from(this.reportTitle).some((char) => INVALID_TITLE_CHARS.has(char))) {
            this.errorMessages.titleChars = INVALID_TITLE_CHARACTERS_ERROR;
        }
        this.isValid = this.errorMessagesAsArray().length === 0;
    }
    errorMessagesAsArray() {
        const messageArray = Array.from(Object.values(this.errorMessages));
        return messageArray.filter((error) => error != null);
    }
    submitReportTitle() {
        this.isFirstAttempt = false;
        this.validateReportTitle();
        if (!this.isValid)
            return;
        this.submitHandler.emit(this.reportTitle);
        this.closeModal();
    }
    closeModal() {
        this.resetAll();
        this.isOpen = false;
    }
    openModal() {
        this.isOpen = true;
        this.resetAll();
    }
}
PdfTitleModalComponent.ɵfac = function PdfTitleModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PdfTitleModalComponent)(); };
PdfTitleModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PdfTitleModalComponent, selectors: [["ycn-pdf-title-modal"]], inputs: { defaultTitle: "defaultTitle", checkInvalidCharacters: "checkInvalidCharacters", submitButtonText: "submitButtonText", maxTitleLength: "maxTitleLength" }, outputs: { submitHandler: "submitHandler" }, standalone: false, decls: 15, vars: 12, consts: [[3, "closeModalHandler", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], [1, "form-row"], [1, "form-label"], [1, "form-control", "field-input", 3, "focus", "ngModelChange", "placeholder", "ngModel", "ngClass"], [1, "modal-footer", "user-select-none"], [1, "popupFooter"], ["class", "feedback feedback-invalid", 3, "textContent", 4, "ngFor", "ngForOf"], [1, "modal-footer-actions"], ["type", "button", 1, "btn", "btn-text", 3, "click"], ["type", "button", "tabindex", "0", 1, "btn", "btn-primary", 3, "click", "ngClass"], [1, "feedback", "feedback-invalid", 3, "textContent"]], template: function PdfTitleModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function PdfTitleModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function PdfTitleModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4);
        i0.ɵɵelement(5, "div", 5);
        i0.ɵɵelementStart(6, "input", 6);
        i0.ɵɵlistener("focus", function PdfTitleModalComponent_Template_input_focus_6_listener() { return ctx.isOpen; });
        i0.ɵɵtwoWayListener("ngModelChange", function PdfTitleModalComponent_Template_input_ngModelChange_6_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.reportTitle, $event) || (ctx.reportTitle = $event); return $event; });
        i0.ɵɵlistener("ngModelChange", function PdfTitleModalComponent_Template_input_ngModelChange_6_listener() { return ctx.validateReportTitle(); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(7, "div", 7)(8, "div", 8);
        i0.ɵɵtemplate(9, PdfTitleModalComponent_div_9_Template, 1, 1, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 10)(11, "div", 11);
        i0.ɵɵlistener("click", function PdfTitleModalComponent_Template_div_click_11_listener() { return ctx.closeModal(); });
        i0.ɵɵtext(12, " Cancel ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 12);
        i0.ɵɵlistener("click", function PdfTitleModalComponent_Template_div_click_13_listener() { return ctx.submitReportTitle(); });
        i0.ɵɵtext(14);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.isOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Edit PDF Title");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("placeholder", "Title");
        i0.ɵɵtwoWayProperty("ngModel", ctx.reportTitle);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0, !ctx.isValid));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.errorMessagesAsArray());
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c1, !ctx.isValid));
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate1(" ", ctx.submitButtonText, " ");
    } }, dependencies: [i1.ModalBaseComponent, i2.SimpleModalHeaderComponent, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgModel, i4.NgClass, i4.NgForOf], encapsulation: 2 });
